<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">Impresszum</h1>
        <p class="mb-16 text-center"><strong>Adatkezelő adatai</strong></p>
        <table class="mx-auto">
            <tbody>
                <tr>
                    <td class="pr-4">Név:</td>
                    <td>Pipacs Pékség Kft.</td>
                </tr>
                <tr>
                    <td class="pr-4">Székhely:</td>
                    <td>1033 Budapest, Szentendrei út 95.</td>
                </tr>
                <tr>
                    <td class="pr-4">Kapcsolati adatok:</td>
                    <td>info@pipacspekseg.hu</td>
                </tr>
                <tr>
                    <td class="pr-4">Cégjegyzékszám:</td>
                    <td>01-09-305671</td>
                </tr>
                <tr>
                    <td class="pr-4">Adószám:</td>
                    <td>26169718-2-41</td>
                </tr>
                <tr>
                    <td class="pr-4">Nyilvántartásba vételt elrendelő hatóság</td>
                    <td>Fővárosi Törvényszék Cégbírósága</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script setup lang="ts">
</script>